/* Group order picker: see sections/group-order.liquid. */
(() => {
  const root = document.querySelector('[data-group-order]');
  if (!root) return;

  const $ = (selector) => root.querySelector(selector);
  const steppers = [...root.querySelectorAll('[data-go-stepper]')];
  const bar = $('[data-go-bar]');
  const line1 = $('[data-go-line1]');
  const line2 = $('[data-go-line2]');
  const add = $('[data-go-add]');
  const error = $('[data-go-error]');
  const addLabel = add.textContent;

  const freeFrom = Number(root.dataset.freeFrom || 0);
  const tiers = (root.dataset.tiers || '')
    .split(',')
    .filter(Boolean)
    .map((tier) => tier.split(':').map(Number))
    .sort((a, b) => a[0] - b[0]);
  const base = steppers.length ? Number(steppers[0].dataset.base) : 0;

  // The store's money format, like theme.js, without ".00": "R 1,000", "R 299.99".
  const money = (cents) => {
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const format = (window.VS && window.VS.moneyFormat) || 'R {{amount}}';
    return format.replace(/\{\{\s*amount\w*\s*\}\}/, amount).replace(' ', '\u00a0');
  };

  const unitFor = (pairs) => {
    let unit = base;
    tiers.forEach(([from, price]) => {
      if (pairs >= from) unit = price;
    });
    return unit;
  };

  const counts = new Map();
  const total = () => [...counts.values()].reduce((sum, n) => sum + n, 0);

  const nextStep = (pairs) => tiers.find(([from]) => from > pairs);

  const update = () => {
    const pairs = total();
    const unit = unitFor(pairs);
    add.disabled = pairs === 0;
    error.hidden = true;
    if (pairs === 0) {
      line1.textContent = root.dataset.tEmpty;
      const best = tiers[tiers.length - 1];
      line2.textContent = best ? `${best[0]} or more pairs: ${money(best[1])} each` : '';
      return;
    }
    const free = freeFrom > 0 && pairs >= freeFrom;
    line1.textContent = `${pairs} ${pairs === 1 ? 'pair' : 'pairs'}: ${money(unit * pairs)}${free ? ', delivered free' : ' + delivery'}`;
    const next = nextStep(pairs);
    if (next) {
      const more = next[0] - pairs;
      line2.textContent = `Add ${more} more and all ${next[0]} are ${money(next[1])} each`;
    } else {
      line2.textContent = `Best price: ${money(unit)} a pair`;
    }
  };

  steppers.forEach((stepper) => {
    const id = Number(stepper.dataset.id);
    const max = Number(stepper.dataset.max);
    const minus = stepper.querySelector('[data-go-minus]');
    const plus = stepper.querySelector('[data-go-plus]');
    const count = stepper.querySelector('[data-go-count]');
    const set = (n) => {
      counts.set(id, n);
      count.textContent = n;
      minus.disabled = n <= 0;
      plus.disabled = n >= max;
      update();
    };
    minus.addEventListener('click', () => set(Math.max(0, (counts.get(id) || 0) - 1)));
    plus.addEventListener('click', () => set(Math.min(max, (counts.get(id) || 0) + 1)));
    counts.set(id, 0);
    plus.disabled = max <= 0;
  });

  add.addEventListener('click', async () => {
    const items = [...counts.entries()].filter(([, n]) => n > 0).map(([id, quantity]) => ({ id, quantity }));
    if (!items.length) return;
    add.disabled = true;
    add.textContent = root.dataset.tAdding;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error(String(response.status));
      window.location.href = '/cart';
    } catch (e) {
      add.disabled = false;
      add.textContent = addLabel;
      error.textContent = root.dataset.tError;
      error.hidden = false;
    }
  });

  const whatsapp = $('[data-go-whatsapp]');
  const link = `${root.dataset.shareUrl}?utm_source=whatsapp&utm_medium=share&utm_campaign=group-orders`;
  whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`${root.dataset.shareText} ${link}`)}`;

  [$('[data-go-list]'), $('[data-go-sizes]'), $('[data-go-share]'), bar].forEach((el) => {
    el.hidden = false;
  });
  update();
})();
